module.exports = __webpack_public_path__ + "img/Blog Admin 1.5c04595d.png";